import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../../context/language';
import SelectBank from '../../Banks';
import InputLabel from '@material-ui/core/InputLabel';
import { getStrLang } from '../../Translate';
import { getAceiteTermos } from '../../../api/fastcoinService';
import { Modal, Button } from 'react-bootstrap';
import Ted from '../../tedComponentes/Ted';
import { IoChevronBackOutline } from 'react-icons/io5';
import Timer from '../../Timer';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const OptTed = (props) => {
    //Chamada para as variáveis e funções do Context
    const { translate, lang, orderFromDeposit, setBankSelected, bankSelected } = useLanguage();
    //Hooks
    const country = sessionStorage.getItem("country").toLocaleLowerCase();
    //Controle do modal
    const [show, setShow] = useState(sessionStorage.getItem("popup_ted") === "false" ? false : true);
    const [bankOptions, setbankOptions] = useState(JSON.parse(sessionStorage.getItem("bank_info")));
    const handleClose = () => {
        sessionStorage.setItem("popup_ted", "false");
        setShow(false)
    };
    const [opt_payment, setOpt_payment] = useState("");
    const [pg_payment, setPg_payment] = useState("");
    const [selectedPayment, setSelectedPayment] = useState("");
    const [expirado, setExpirado] = useState(false);

    //valida se os termos da ordem foram aceitos
    useEffect(() => {
        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    //console.log(res);
                    if (res !== undefined) {
                        props.setShowTermos(false);
                    } else {
                        props.setShowTermos(true);
                    }
                    translate();
                })
                .catch(err => {
                    if (err.error.includes("Could not find")) {
                        console.log(err);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                    props.setShowTermos(true);
                })
        }
        if (orderFromDeposit !== "") {
            validarTermos();
        }
    }, []);

    //Retorna quais bancos estão disponíveis para o país desejado
    //As informações dos bancos, ficam no Componente ../Banks

    //Traduz o texto na tela quando mudado o idioma pelo usuário ou quando muda o banco
    useEffect(() => {
        translate();
    }, [translate, country]);

    //Escolhendo um banco diferente
    //verificar como vai ficar quando tiver mais bancos

    const handleChangeBank = (event) => {
        //setbankOptions(formatarCnpj(bankOptions));      
        setBankSelected(event);
        SelectBank(bankOptions, event);
    };

    //console.log(bankSelected === undefined ? bankOptions?.filter(item => item.bank_name === bankSelected)[0].bank_name : bankSelected);

    const ItemOptionPayment = (props) => {
        translate();
        return (
            <div className='btn-home' onClick={() => { handleChangeBank(props.optionName); setPg_payment([props.optionComponent]) }}>
                <div className='imgLogo'>
                    <img src={props.icon} height={50} style={{ marginRight: 20 }} />
                </div>
                <div className='imgLogo'>
                    <InputLabel htmlFor="filled-age-native-simple" className='btn-home-text'>{props.optionName}</InputLabel>
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (bankOptions) {
            let optPay = [];
            bankOptions.map(e => {
                optPay.push(<ItemOptionPayment icon={e.logo} optionName={e.bank_name.substr((e.bank_name.indexOf('-') + 1))} optionComponent={<Ted setShowTermos={props.setShowTermos} selectedBank={e.bank_name} />} />);
            });
            setOpt_payment(optPay);
        }
    }, []);


    return (
        <div style={{ height: '100%' }}>
            <div className='optionPaymentArea'>
                {pg_payment ?
                    <div className='optionPayment'>
                        <Timer countdown={120} setExpirado={setExpirado} />
                        {!expirado && <>
                        <div className='optionPaymentHeader'>                           
                            <div className="column-pix-sides">
                                <button className="btn-split-pix" onClick={() => setPg_payment(undefined)}><IoChevronBackOutline size={25} /> {getStrLang(lang.nameLang, "btn_voltar")}</button>
                            </div>
                            <h4 data-lang-str={selectedPayment}></h4>
                            <div style={{ width: '50px' }}> </div>
                        </div>
                        {pg_payment}</>}
                        {expirado &&  <p className="center footer_pix"><b>{getStrLang(lang.nameLang, "payment_expiration")}</b></p>}
                    </div>
                    :
                    <div className='optionsPaymentsHomeContainer'>
                        <div className='optionsPaymentsHome'>
                            {opt_payment}
                        </div>
                        <span className="main_info">{getStrLang(lang.nameLang, "limit_amount_order")}</span>
                    </div>
                }
            </div>

        </div>
    )
}

export default OptTed;